import { render, staticRenderFns } from "./RealtyRequest.vue?vue&type=template&id=645a505b&"
import script from "./RealtyRequest.vue?vue&type=script&lang=js&"
export * from "./RealtyRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports